import { gql, useMutation } from '@apollo/client'
import {
  MutationVehicleCommandExecuteArgs,
  MutationVehicleCommandExecutePayload,
} from 'src/generated'

const MUTATION_VEHICLE_COMMAND_EXECUTE = gql`
  mutation VehicleCommandExecute($input: MutationVehicleCommandExecuteInput!) {
    vehicleCommandExecute(input: $input) {
      success
    }
  }
`

const useVehicleCommandExecuteMutation = () => {
  return useMutation<
    { vehicleCommandExecute: MutationVehicleCommandExecutePayload },
    MutationVehicleCommandExecuteArgs
  >(MUTATION_VEHICLE_COMMAND_EXECUTE)
}

export default useVehicleCommandExecuteMutation
